import { compact, each, go, html, reject, tap } from 'fxjs/es';
import anime from 'animejs';
import { marpplizer_home } from './home.js';
import { marpplizer_cv_text_image } from './cv_text_image.js';
import {
  $appendTo,
  $delegate,
  $el,
  $find,
  $hide,
  $on,
  $qs,
  $remove,
  $setAttr,
  $setCss,
  $show,
} from 'fxdom/es';
import { marpplizerCvOldTextImage } from './cv_old_text.js';
import { marpplizerImage } from './cv_image.js';
import { makeOpacityFunctionEvent } from '../opacity.js';
import { setIScroll } from './fs.js';
import { isShadeStyle } from '../CvPreview/Shade/render.js';
import { getCurrentFcanvas } from '../Fcanvas/cv_object.js';
import { NewMakerRangeSliderF } from '../../../NewMaker/RangeSlider/F/Function/module/NewMakerRangeSliderF.js';
import { NewMakerCvObjectCvBackgroundF } from '../../../NewMaker/CvObject/CvBackground/F/Function/module/NewMakerCvObjectCvBackgroundF.js';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';
import tippy from 'tippy.js';
import { NewMakerCallConditionPopupF } from '../../../NewMaker/CallConditionPopup/F/Function/module/NewMakerCallConditionPopupF.js';
import { NewMakerConditionAgreeTextF } from '../../../NewMaker/ConditionAgreeText/F/Function/module/NewMakerConditionAgreeTextF.js';
import { legacyHtml } from '../../../Util/S/Function/util.js';
import { NewMakerPropertyBaseProductConstantS } from '../../../NewMaker/Property/BaseProduct/S/Constant/module/NewMakerPropertyBaseProductConstantS.js';
import { getBaseProductInMaker } from '../getSth.js';
import { OMPCoreUtilF } from '../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { MobileAddToCart } from '../../../../services/Marpple/client/shared/ui/cells/MobileAddToCart/MobileAddToCart.ts';
import { MpMakerMconUtil } from '@modules/NewMaker/Mcon/S/Function/mcon.ts';

function getRoute(cv_active, base_product) {
  const has_function_of_is_inverted_image =
    base_product.maker_features?.[NewMakerPropertyBaseProductConstantS.INVERTED_IMAGE];
  const cv_type =
    !MpMakerMconUtil.getMconThemeId(cv_active) &&
    ((!has_function_of_is_inverted_image &&
      isShadeStyle(getCurrentFcanvas()) &&
      cv_active &&
      cv_active._data.cv_type === 'cv_image') ||
      cv_active?._data?.is_embro ||
      G.mp.maker.flexiMaker)
      ? 'home'
      : cv_active && cv_active._data?.cv_type;
  if (cv_type === 'cv_image' || cv_type === 'cv_pattern') return 'image';
  else if (cv_type === 'cv_text') return 'text';
  else if (cv_type === 'cv_pure_text') return 'text';
  else if (cv_type === 'cv_text_image' || cv_type === 'cv_text_image_pattern') return 'text';
  else if (cv_type === 'cv_old_text') return 'old_text';
  else if (cv_type === 'cv_background') return 'cv_background';
  else return 'home';
}

export const mpMakerLoaderStart = function () {
  mpMakerLoaderEnd();
  return go(html` <div class="don_loader_mp_maker_wrap"></div> `, $el, $appendTo($qs('body')));
};
export const mpMakerLoaderEnd = function () {
  go([$qs('.don_loader_mp_maker_wrap')], compact, each($remove));
};

export async function marpplizerProxy(cv_active) {
  if (box.sel('shared_product')) {
    // vector 옵션 바뀔때 변경사항 저장하기 활성화
    if (UtilF.isLegacyMobile()) {
      OMPCoreUtilF.hydrationRune(MobileAddToCart);
    }
    if (G.mp.maker.is_shared_product_design_changed) G.mp.maker.is_shared_product_design_changed();
  }
  if (UtilF.isLegacyMobile()) return;
  const base_product = getBaseProductInMaker();

  const route = getRoute(cv_active || G.mp.maker.active(), base_product);
  try {
    mpMakerLoaderStart();
    await openMarpplizer(route, cv_active || { cid: _p.uniqueId('c') });
  } catch (e) {
    if (e.message === 'no_active' || e.message === 'wrong_data' || e.message === 'same_cid') {
      /*
       * TODO jip 언젠가......
       * */
    } else {
      console.error(e);
    }
  } finally {
    mpMakerLoaderEnd();
    $.don_loader_end();
  }
}

const event = $delegate('click', '.marpplizer_back_btn', async function () {
  G.mp.maker.unselect_all();
});

function destroyTippy() {
  const marpplizer_el = $qs('#marpplizer');
  if (!marpplizer_el) return;
  if (marpplizer_el.__tippies?.length) {
    go(
      marpplizer_el.__tippies,
      each((_tippy) => !_tippy?.state?.isDestroyed && _tippy.destroy()),
    );
    marpplizer_el.__tippies = [];
  }
}
const removed_tooltips = new Set();
function activeTippy(marpplizer_contents_wrapper_el, tooltips) {
  // const is_shared_product = $qs('.mp_maker').dataset.is_shared_product === 'true';
  const marpplizer_el = $qs('#marpplizer');
  if (!marpplizer_el) return;
  marpplizer_el.__tippies = [];
  go(
    tooltips,
    reject((tooltip) => removed_tooltips.has(tooltip.target_unique_class)),
    each((tooltip) => {
      const target_el = go(marpplizer_contents_wrapper_el, $find(tooltip.target_unique_class));

      if (G.mp.maker.nfcProduct && tooltip.target_unique_class === '.group_discount_guide') return;
      if (!target_el) return;
      // if (
      //   is_shared_product &&
      //   tooltip.target_unique_class !== '#to_save_changes_vector' &&
      //   tooltip.target_unique_class !== '#to_save_changes'
      // )
      //   return;
      marpplizer_el.__tippies.push(
        tippy(target_el, {
          content: tooltip.content,
          allowHTML: true,
          theme: 'maker-marpplizer',
          showOnCreate: true,
          placement: 'top',
          maxWidth: 'none',
          appendTo: marpplizer_contents_wrapper_el,
          trigger: 'manual',
          onShown(instance) {
            go(
              instance.popper,
              $on('click', () => {
                instance.destroy();
                removed_tooltips.add(tooltip.target_unique_class);
              }),
              $setCss({ 'pointer-events': 'initial' }),
            );
            // ...
          },
          hideOnClick: false,
        }),
      );
    }),
  );
}
const current_ui = { animes: [] };
async function render(activity_attr) {
  destroyTippy();
  current_ui.animes?.forEach((anime) => {
    anime.pause();
  });
  const base_el = $qs(
    `#marpplizer .marpplizer_wrapper >.${activity_attr.app === 'base1' ? 'home' : 'activitys'}`,
  );
  await go(
    undefined,
    () => {
      const activity = base_el.querySelector('.activity');
      if (activity) {
        activity.outerHTML = activity_attr.html;
      } else {
        go($el(activity_attr.html), $appendTo(base_el));
      }
    },
    () => {
      const new_activity = base_el.querySelector('.activity');
      go(new_activity, tap(activity_attr.event));
      return new_activity;
    },
    async () => {
      const activitys = $qs('#marpplizer .marpplizer_wrapper >.activitys');
      const marpple_home = $qs('#marpplizer .marpplizer_wrapper >.home');
      if (activity_attr.app === 'base1') {
        $show(marpple_home);
        $setAttr({ app: 'base1' }, $qs('#marpplizer'));
        current_ui.animes = [
          anime({
            targets: [marpple_home],
            translateX: 0,
            opacity: 1,
            duration: 200,
            easing: 'easeInOutQuart',
          }),
          anime({
            targets: [activitys],
            translateX: '20%',
            opacity: 0,
            duration: 200,
            easing: 'easeInOutQuart',
            complete: () => {
              $hide(activitys);
            },
          }),
        ];
      } else {
        $show(activitys);
        $setAttr({ app: 'base2' }, $qs('#marpplizer'));
        current_ui.animes = [
          anime({
            targets: [activitys],
            translateX: 0,
            opacity: 1,
            duration: 200,
            easing: 'easeInOutQuart',
          }),
          anime({
            targets: [marpple_home],
            translateX: '-20%',
            opacity: 0,
            duration: 200,
            easing: 'easeInOutQuart',
            complete: () => {
              $hide(marpple_home);
            },
          }),
        ];
      }
    },
    () => {
      const new_activity = base_el.querySelector('.activity');
      go(
        new_activity,
        tap(NewMakerRangeSliderF.start),
        tap(setIScroll),
        tap(makeOpacityFunctionEvent),
        $delegate('click', '.marpplizer_back_btn', async function () {
          G.mp.maker.unselect_all();
        }),
      );
      return new_activity;
    },
    (el) => {
      if (activity_attr.tooltips?.length) {
        activeTippy(go(el, $find('.marpplizer_contents_wrapper')), activity_attr.tooltips);
      }
    },
  );
}

const openMarpplizer = function (route) {
  return go(
    undefined,
    () => {
      if (route === 'home') {
        if (G.mp.maker.custom_marpplizer?.home) {
          return G.mp.maker.custom_marpplizer?.home();
        }
        return marpplizer_home();
      }
      if (route === 'text') {
        if (G.mp.maker.custom_marpplizer?.text) {
          return G.mp.maker.custom_marpplizer?.text();
        }
        return marpplizer_cv_text_image();
      }
      if (route === 'old_text') {
        return marpplizerCvOldTextImage();
      }
      if (route === 'image') {
        if (G.mp.maker.custom_marpplizer?.image) {
          return G.mp.maker.custom_marpplizer?.image();
        }
        return marpplizerImage();
      }
      if (route === 'cv_background') {
        if (G.mp.maker.custom_marpplizer?.background) {
          return G.mp.maker.custom_marpplizer?.background();
        }
        return NewMakerCvObjectCvBackgroundF.marpplizerCvBackground();
      }
    },
    render,
    tap(() => {
      // NOTE: 조건 팝업 매핑된 상품일 시 디자인할 요소가 비활성화 되었을 시에는 장바구니 담기 버튼 x
      const general_option_buttons = $qs('.general_option_buttons');
      if (route === 'home') {
        if (G.mp.maker.generalButtonMaker) {
          G.mp.maker.generalButtonMaker();
        }
        $show(general_option_buttons);
        const shared_product = box.sel('shared_product');
        if (shared_product) {
          const x_image = html`<img src="//s3.marpple.co/files/u_193535/2024/3/original/846518fd0bf13a97986b396befa3002aac127f771.png"
            style="width:8px;height:8px;margin-left:8px;" alt=""></img>`;
          activeTippy($qs('#marpplizer'), [
            {
              content: go(
                html`
                  <div style="text-align: center;">
                    <span>${TT('maker_upload_type::디자인을 저장하지 않으면 변경사항이 사라져요!')}</span
                    >${x_image}
                  </div>
                `,
                $el,
              ),
              target_unique_class: '#to_save_changes',
            },
            {
              content: go(
                html`
                  <div style="text-align: center;">
                    <span>${TT('maker_upload_type::디자인을 저장하지 않으면 변경사항이 사라져요!')}</span
                    >${x_image}
                  </div>
                `,
                $el,
              ),
              target_unique_class: '#to_save_changes_vector',
            },
          ]);
        }
      } else {
        $hide(general_option_buttons);
      }
    }),
    async () => {},
  );
};

export const resetMainConditionAgreeText = () => {
  const condition_agree_text_el = $qs('.general_option_buttons .condition_agree_text');
  if (!condition_agree_text_el) return;

  const html_warning = NewMakerConditionAgreeTextF.fn(null, true);
  condition_agree_text_el.innerHTML = html_warning;
};

export const makeMarppleShopMarpplizerHtml = () => {
  const btn_disabled =
    NewMakerCallConditionPopupF.is_real_mapping_confirm_popup() &&
    NewMakerConditionAgreeTextF.getAgreeTextData(null, true)?.length;

  const html_warning = NewMakerConditionAgreeTextF.fn(null, true);
  return legacyHtml`
    <div id="marpplizer">
      <div class="wrapper iscroll_wrapper">
        <div class="marpplizer_wrapper iscroll_ul_wrapper">
          <div class="home"></div>
          <div class="activitys" style="opacity:0; transform: translateX(20%);"></div>
        </div>
      </div>
      <div class="general_option_buttons">
        <div class="condition_agree_text" data-route="home">${html_warning}</div>
        <div id="to_vector_editor">
          <div class="border_box">
            <div class="text">${T('Start Creating')}</div>
            <div class="border"></div>
            <div class="one deco"></div>
            <div class="two deco"></div>
            <div class="three deco"></div>
            <div class="four deco"></div>
          </div>
        </div>
        <button id="to_next" class="buying marpplizer_footer maker_go_next mp_maker_done ${
          btn_disabled ? 'btn_disabled' : ''
        }" type="button">${T('Design Complete')}</button>
      </div>
    </div>
  `;
};

export const makeMpMarpplizerHtml = () => {
  return legacyHtml`
    <div id="marpplizer">
      <div class="wrapper iscroll_wrapper">
        <div class="marpplizer_wrapper iscroll_ul_wrapper">
          <div class="home"></div>
          <div class="activitys" style="opacity:0; transform: translateX(20%);"></div>
        </div>
      </div>
      <div class="general_option_buttons"></div>
    </div>
  `;
};
